module.exports = __webpack_public_path__ + "static/media/slider5.3aff2059.jpg";